<template>
  <div class="text-green-400 text-center text-xl">
    <p class="text-white text-xl font-bold " v-if="!internalError">الرجاء الانتظار ....</p>
    <h1 class="text-gray-500 text-4xl text-center mt-36" v-if="internalError">500|Server </h1>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth';
import { mapActions, mapState } from 'pinia';
export default {
  data() {
    return {
      internalError: false
    }
  },
  mounted() {
    const script = document.createElement('script')
    script.id = 'gtm-script'
    script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-5SHXGLDW');
    `
    document.head.appendChild(script)
  },
  beforeUnmount() {
    const script = document.head.querySelector('#gtm-script') // Use the id to select the script
    if (script) {
      document.head.removeChild(script)
    }
  },
  computed: {
    ...mapState(useAuthStore, ['isAuthenticated']),
  },
  methods: {
    ...mapActions(useAuthStore, ["checkSubescriptionStatus"]),
    checkResoponse(response) {
      if (response.data.responseMessage == "The token invalid or expired, try to re login.") {
        this.internalError = true
      } else if (response.data.isActive) {
        this.$router.push({ name: "subscribe" })
      }
    }
  },
  async created() {

    try {
      await this.checkSubescriptionStatus(this.$route.params.num).then((response) => this.checkResoponse(response))

      if (localStorage.getItem("status")) {
        setTimeout(() => {
          this.$router.push({ name: "home" })
        }, 6000);
      }
    } catch (error) {
      console.log(error);
    }




  }


}
</script>

<style></style>